// export const HOST = "https://anonrooms.helioho.st";
// export const HOST = "https://testzsh.helioho.st";
export const UPLOADCARE_PUBKEY = "b182e75f948ada5a015f";
export const CORS_PROXY = "http://localhost:8094";
// export const CORS_PROXY = "https://cors-anywhere-datae.helioho.st";
// export const CORS_PROXY = "https://ba0f-35-237-200-167.ngrok-free.app"
// export const CORS_PROXY = "https://rear-etc-adrian-phase.trycloudflare.com";

// export const HOST = "https://www.google.com";
// export const HOST = "http://localhost:8081";
export const HOST = "";
export const sliceSize = 99 * 1024 * 1024; // 99MB
// export const sliceSize = 20 * 1024 * 1024; // 2MB
